import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import OrderServiceV2 from '../../services/v2/OrderServiceV2';

const orderServiceV2 = OrderServiceV2();

export const REACT_QUERY_GET_ORDERS_V2_QUERY_KEY = 'getOrdersV2';
export const REACT_QUERY_GET_ORDER_V2_QUERY_KEY = 'getOrderV2';
export const REACT_QUERY_GET_ADMIN_ORDERS_V2_QUERY_KEY = 'getAdminOrdersV2';
export const REACT_QUERY_GET_ADMIN_ORDER_V2_QUERY_KEY = 'getAdminOrderV2';

const QUERY_KEY_ORDERS = [REACT_QUERY_GET_ORDERS_V2_QUERY_KEY];

export const useGetOrdersV2 = (params = {}, options = {}) => {
  const query = useQuery({
    queryKey: [...QUERY_KEY_ORDERS, params],
    queryFn: () => orderServiceV2.getOrders(params),
    ...options,
  });

  return {
    ...query,
    data: query.data || {},
  };
};

export const useGetOrderByIdV2 = (id, options = {}) => {
  const query = useQuery({
    queryKey: [REACT_QUERY_GET_ORDER_V2_QUERY_KEY, id],
    queryFn: () => orderServiceV2.getOrderById(id),
    enabled: !!id,
    ...options,
  });

  return {
    ...query,
    data: query.data || {},
  };
};

export const useCreateOrderShoppingCartV2 = (options = {}) => {
  return useMutation({
    mutationFn: orderServiceV2.createOrderShoppingCart,
    ...options,
  });
};

export const useCreateOrderBuyNowV2 = (options = {}) => {
  return useMutation({
    mutationFn: orderServiceV2.createOrderBuyNow,
    ...options,
  });
};

export const useGetAdminOrdersV2 = (params = {}, options = {}) => {
  const query = useQuery({
    queryKey: [REACT_QUERY_GET_ADMIN_ORDERS_V2_QUERY_KEY, params],
    queryFn: () => orderServiceV2.getAdminOrders(params),
    ...options,
  });

  return {
    ...query,
    data: query.data || {},
  };
};

export const useGetAdminOrderByIdV2 = (id, options = {}) => {
  const query = useQuery({
    queryKey: [REACT_QUERY_GET_ADMIN_ORDER_V2_QUERY_KEY, id],
    queryFn: () => orderServiceV2.getAdminOrderById(id),
    enabled: !!id,
    ...options,
  });

  return {
    ...query,
    data: query.data || {},
  };
};

export const useConfirmAdminOrderV2 = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => orderServiceV2.confirmAdminOrder(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [REACT_QUERY_GET_ADMIN_ORDERS_V2_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [REACT_QUERY_GET_ADMIN_ORDER_V2_QUERY_KEY] });
    },
    ...options,
  });
};

export const useEstimateDeliveryV2 = (options = {}) => {
  return useMutation({
    mutationFn: orderServiceV2.estimateDelivery,
    ...options,
  });
};

export const useRejectAdminOrderV2 = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => orderServiceV2.rejectAdminOrder(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [REACT_QUERY_GET_ADMIN_ORDERS_V2_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [REACT_QUERY_GET_ADMIN_ORDER_V2_QUERY_KEY] });
    },
    ...options,
  });
};
